import Preact, { Component, h } from 'preact'
import { isChangeEvent } from '../../libs/typeGuards'

interface Props {
  class: string
  placeholder?: string
  maxLength?: number | undefined
  onContentChange?: (value: string) => void
  onTextareaFocus?: () => void
  value?: string | number
  error?: boolean
  disabled?: boolean
  newStyle?: boolean
  verticalResize?: boolean
  adjustHeight?: boolean
  isDestination?: boolean
}

class Textarea extends Component<Props> {
  textareaElement = Preact.createRef()
  constructor (props: Props) {
    super(props)
    this.adjustHeight = this.adjustHeight.bind(this)
  }

  componentDidUpdate () {
    if (this.props.adjustHeight) {
      this.adjustHeight()
    }
  }

  adjustHeight () {
    const el = this.textareaElement
    const outerHeight = parseInt(window.getComputedStyle(el).height, 10)
    const diff = outerHeight - el.clientHeight
    el.style.height = '48px'
    el.style.height = String(parseInt(el.scrollHeight) + diff) + 'px'
  }

  render ({ class: customClass, placeholder, maxLength, onContentChange, onTextareaFocus, value, error, disabled = false, newStyle = false, verticalResize = false, adjustHeight = true, isDestination = false }: Props) {
    if (error) {
      customClass += ' error'
    }

    if (disabled) {
      customClass += ' disabled'
    }

    if (newStyle) {
      customClass += ' textarea-new'
    }

    if (verticalResize) {
      customClass += ' textarea-vertical'
    }

    if (isDestination) {
      customClass += ' textarea-destination'
    } else {
      customClass += ' textarea-control'
    }

    return (
      <textarea
        className={customClass}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        onChange={(e) => {
          if (onContentChange && isChangeEvent(e)) {
            onContentChange((e.target).value)
          }
        }}
        onClick={onTextareaFocus}
        value={value}
        onInput={() => {
          if (adjustHeight) {
            this.adjustHeight()
          }
        }}
        ref={textarea => { this.textareaElement = textarea }}
      />
    )
  }
}

export default Textarea
